import React from "react";
import { AiOutlineBook } from "react-icons/ai";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { FaUserCheck, FaUsersSlash, FaQuestion } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const GroupReportCard = ({ group, analytics, loading, module }) => {
  let navigate = useNavigate();
  const { totalCounts, userBreakdown, duration, errors , errorsPerUser, quizScore} = analytics;
  const GroupReportData = [
    {
      id: 1,
      title: "Times Played",
      count: totalCounts.all,
      navigate :  true,
      navigateLink : `/module/group/user/played/${group.uuid}/${module.uuid}`,
      subHeaders: [
        {
          label: "Guided",
          count: totalCounts.guided,
        },
        {
          label: "Unguided",
          count: totalCounts.unguided,
        },
      ],
      icons: <AiOutlineBook />,
    },
    {
      id: 2,
      title: "Users",
      count: userBreakdown.total,
      subHeaders: [
        {
          label: "Active",
          count: userBreakdown.active,
        },
        {
          label: "Inactive",
          count: userBreakdown.inactive,
        },
      ],
      icons: <FaUserCheck />,
    }
    // ,
    // {
    //   id: 3,
    //   title: "Time Spent Average",
    //   count: duration.all.average.humanReadable,
    //   subHeaders: [
    //     { label: "Guided", count: duration.guided.average.humanReadable },
    //     { label: "Unguided", count: duration.unguided.average.humanReadable },
    //   ],
    //   icons: <FaUsers />,
    // }
    ,
    {
      id: 3,
      title: "Average Errors Per Iteration",
      count: errors.unguided || 0,
      subHeaders: [],
      icons: <FaUsersSlash />,
    },
    {
      id: 4,
      title: "Average Errors Per User",
      count: errorsPerUser || 0,
      subHeaders: [],
      icons: <FaUsersSlash />,
    },
    {
      id: 5,
      title: "Quiz",
      count: quizScore.total || 0,
      navigate :  true,
      navigateLink : `/module/report/group/attempted/quiz/${group.uuid}/${module.uuid}`,
      subHeaders: [
        {
          label: "Max Score",
          count: quizScore.max,
        },
        {
          label: "Avg Score",
          count: quizScore.avg,
        },
      ],
      icons: <FaQuestion  />,
    }
  ];
  return (
    <>
      {GroupReportData.map((edata, index) => (
        <div
          className="ReportStat_Box"
          key={edata.id}
        >
          <div className="cardbodyitems py-1" style={{ height:"100%" }}  onClick={ edata.count > 0 && edata.navigate ? () => navigate(edata.navigateLink, {state:{ group: group.name , module: module.name }}) : null}>

            <div className="dattacardd p-0" style={{ height:"100%" }}>
              <div className="card-header p-2">
                <div className="infodetail date date-counter">
                  <p className="text-sm mb-1 text-capitalize">{edata.title}</p>
                  <h4>{ loading ? <Skeleton width="5vw"/> :  <>{edata.count}</> }</h4>
                </div>
                <div className="icon">{edata.icons}</div>
              </div>
              <div className="mode px-2 pb-2">
                { loading ? 
                  <Skeleton width="5vw"/> :
                  <>
                {edata.subHeaders.map((e, index) => {
                  return (
                    <span key={index}>
                      {e.label}: {e.count}
                    </span>
                  );
                })}
                </>
                }
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default GroupReportCard;
